import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddressAutocompleteComponent } from "./address-autocomplete.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [AddressAutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [AddressAutocompleteComponent],
})
export class AddressAutocompleteModule {}
